<template>
  <page-outline :title="$t('contacts.edit_contact')"
    iconFA="address-book">

    <template slot="pageContent">
      <form-accordion :title="$t('common.contact_ids')">
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" class="custom-control-input" id="defaultInline1" name="inlineDefaultRadiosExample" value="1" v-model="typeContact" checked>
            <label class="custom-control-label" for="defaultInline1">
              {{ $t('common.indiv') }}
            </label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" class="custom-control-input" id="defaultInline2" name="inlineDefaultRadiosExample" value="2" v-model="typeContact">
            <label class="custom-control-label" for="defaultInline2">
              {{ $t('common.cmpny') }}
            </label>
          </div>
        </div>

        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="username" isMandatory
              :inputLabel="$t('common.nme')" :placeholderValue="$t('common.nme')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="label" isMandatory
              :inputLabel="$t('common.als')" :placeholderValue="$t('common.als')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="typeInd" v-if="typeContact === '1'"
          @click="hideBlock($event)">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="identifier" isMandatory
              :inputLabel="$t('common.eml')" :placeholderValue="$t('common.eml')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="typeCom" v-else
          @click="hideBlock($event)">
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="identifier" isMandatory
              :inputLabel="$t('common.srn')" :placeholderValue="$t('common.srn')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>

      <hr>

      <form-accordion :title="$t('common.formsSubTitle.bank_info')">
        <b-row>
          <b-col sm="6" class="form-group">
            <label>
              {{ $t('common.act') }}
            </label>
            <select class="form-control" id="sel4" v-model="zone" readonly>
              <option v-for="country in countries" :key="country.id"
                :value="country"
                :disabled="country.disabled"
                :selected="country.selected">
                {{ $t('zoneCodes.' + country.label) }}
              </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group" v-for="accountLabel in zone.accountLabel" :key="accountLabel">
            <label>
              {{ $t(accountLabel) }}
              <span class="color-red">* </span>
            </label>
            <input v-model="zone.values[accountLabel]"
              type="text"
              name="identifier"
              class="form-control"
              :placeholder="$i18n.t(accountLabel)">
            </input>
          </b-col>
        </b-row>

        <div v-if="this.$engine.user.currentService.id === '2'">
          <b-row class="form-group">
            <b-col sm="2" md="4">
              <label class="col-form-label">
                {{ $t('bank_accounts.mandat_id') }}
              </label>
            </b-col>
            <b-col sm="10" md="8">
              <input type="text" class="form-control"
                name="mandatId" :placeholder="$i18n.t('bank_accounts.mandat_id')">
              </input>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col sm="2" md="4">
              <label class="col-form-label labelAccordionForm">
                {{ $t('bank_accounts.mandat_date') }}
              </label>
            </b-col>
            <b-col sm="10" md="8">
              <input type="date" class="form-control"
                :placeholder="$i18n.t('bank_accounts.mandat_date')">
              </input>
            </b-col>
          </b-row>
        </div>
      </form-accordion>

      <hr>

      <form-accordion :title="$t('common.formsSubTitle.extra_info')">
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="phoneNumber"
              :inputLabel="$t('common.phn')" :placeholderValue="$t('common.phn')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="address"
              :inputLabel="$t('common.adrs')" :placeholderValue="$t('common.adrs')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="city"
              :inputLabel="$t('common.cty')" :placeholderValue="$t('common.cty')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="zipCode"
              :inputLabel="$t('common.zp_code')" :placeholderValue="$t('common.zp_code')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <form-write-group-label-input v-model="country"
              :inputLabel="$t('common.ctry')" :placeholderValue="$t('common.ctry')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="9" class="form-group">
          <f7-button class="milkyBlockBlack button-action"
            @click="changeContact">
            <i class="icon fa fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {createForeignIban, extractForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'
import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditContact',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      id: '',
      identifier: '',
      username: '',
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '',
      zone: {},
      zoneCode: '',
      countries: '',
      countryPicker: ''
    }
  },
  created () {
    this.id = this.$settings.currentContact.id
    this.username = this.$settings.currentContact.name
    this.identifier = this.$settings.currentContact.identifier
    this.label = this.$settings.currentContact.label
    this.phoneNumber = this.$settings.currentContact.phoneNumber
    this.address = this.$settings.currentContact.address
    this.city = this.$settings.currentContact.city
    this.zipCode = this.$settings.currentContact.zipCode
    this.country = this.$settings.currentContact.country
    this.typeContact = this.$settings.currentContact.typeContact
    this.zone = this.$engine.bankAccounts.getZoneData(this.$settings.currentContact.zoneCode)
    this.zoneCode = this.zone.label

    /** TLV 19/03/2020
    * On extrait les donn�es du faux IBAN en base en vraies donn�es bancaires,
    * en fonction du pays, dans une variable locale appel�e extractedBankData
    */
    let extractedBankData = {}
    if (this.zoneCode !== '' && this.$settings.currentContact.iban !== '') {
      extractedBankData = extractForeignIban(this.$settings.currentContact.iban, this.zoneCode)
    }
    /** TLV 19/03/2020
    * On cr�� une variable locale json, qui va �tre int�gr�e dans this.zone et dans that.countries,
    * qui contient les valeurs actuelles du json pour l'utilisateur s�lectionn�
    */
    let datavalues = {}
    for (var bankData in extractedBankData) {
      datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
    }
    this.zone.values = datavalues
    let that = this
    let label = []
    that.countries = this.$engine.bankAccounts.getZoneCode()
    for (var country in that.countries) {
      if (that.countries[country].label === this.zoneCode) {
        that.countries[country].values = datavalues
      }
    }
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = that.countries.filter(function (country) {
          return country.label === p.value[0]
        })[0]
      }
    })
  },
  methods: {
    changeContact () {
      const that = this

      // Check input formats
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        }
      }

      if (this.identifier.length > 0 && this.typeContact === '1') {
        if (validateEmail(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.eml_adrs')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.eml_adrs')})
          )
          return
        }
      }
      if (this.identifier.length > 0 && this.typeContact === '2') {
        if (validateSIREN(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.srn')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.srn')})
          )
          return
        }
      }
      if (this.phoneNumber.length > 0) {
        if (validatePhoneNumber(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.phn_nbr')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.phn_nbr')})
          )
          return
        }
      }
      if (that.username.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }
      if (that.label.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.als')})
        )
        return
      }

      /* TLV 18/03/2020
      * Cr�ation d'un "faux IBAN" pour enregistrer en base
      */
      let localIban = createForeignIban(this.zone)

      // Edit contact
      this.$engine.contacts.update({
        idContact: this.id,
        identifier: this.identifier,
        name: this.username,
        iban: localIban,
        label: this.label,
        phoneNumber: this.phoneNumber,
        address: this.address,
        city: this.city,
        zipCode: this.zipCode,
        country: this.country,
        typeContact: this.typeContact,
        zoneCode: this.zone.label
      })
      .then(() => {
        that.$f7.modal({
          title: that.$i18n.t('success.updated_success',
            {data: that.$i18n.t(that.$engine.services.getLabelIdOne(that.$engine.user.currentService.id))}),
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          that.identifier = ''
          that.username = ''
          that.label = ''
          that.typeContact = '1'
          that.$bus.$emit('refresh-cache-contacts')
          that.$$(document).off('taphold', '.testTap')
          loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        this.handleError(err) // mixins errorHandlerMixins
      })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>

<style scoped>
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}
/*
ul {
  padding-left: initial;
}*/
</style>



// WEBPACK FOOTER //
// CMEditContact.vue?e1aed6ce